export const DEFAULT_Z_INDEX = '10';
export const ACTIVE_POPUP_Z_INDEX = '8';

export const SELECTORS = {
  NAV_LINK: 'navigation__link',
  NAV_LINK_DEFAULT: 'navigation__link--default'
};

export const DRAWER_SETTLE_MS = 350;
